import { Component, inject } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { VideoDialogData } from "../../../types/telegram-modal.types";
import { MatButton } from "@angular/material/button";
import { GetFileParams } from "../../../types/telegram-page.types";
import { HttpEventType } from "@angular/common/http";
import { TelegramApiService } from "../../../services/telegram-api.service";
import { UploadProgressService } from "../../../../../../core/services/upload-progress.service";
import {
  TelegramUploadStatusComponent
} from "../../telegram-chat-window/components/telegram-upload-status/telegram-upload-status.component";
import { telegramVideoModalName } from "./configs/telegram-video-config";
import { ProgressStatus } from "../../../../../../core/types/upload-progress.types";

@Component({
  selector: 'app-telegram-video-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    TelegramUploadStatusComponent
  ],
  templateUrl: './telegram-video-modal.component.html',
  styleUrl: './telegram-video-modal.component.scss'
})
export class TelegramVideoModalComponent extends BaseModalComponent {
  private dialogData = inject<VideoDialogData>(MAT_DIALOG_DATA);
  private telegramApiService: TelegramApiService = inject(TelegramApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);

  public url: string = '';

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(telegramVideoModalName);
    await this.loadVideo();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(telegramVideoModalName);
    window.URL.revokeObjectURL(this.url);
  }

  private async loadVideo(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    this.url = await this.getVideo({
      remoteId: this.dialogData.remoteId,
      accountId: this.dialogData.accountId
    });
    this.loadingService.setIsLoadingState(false);
  }

  private async getVideo(getFileParams: GetFileParams): Promise<string> {
    return new Promise((resolve, reject) => {
      this.telegramApiService.getVideo(getFileParams).subscribe({
        next: (event) => {
          const progress = this.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: this.dialogData.fileName || '',
            fileType: 'file',
          });

          if (event.type === HttpEventType.Response) {
            const blob = event.body as Blob;
            const url = window.URL.createObjectURL(blob);
            resolve(url); // Возвращаем URL
          }
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        },
        complete: () => {
          setTimeout(() => {
            this.uploadProgressService.resetProgress();
          }, 300);
        },
      });
    });
  }

  private handleUploadEvent(event: any): ProgressStatus {
    switch (event.type) {
      case HttpEventType.DownloadProgress:
        const progress = Math.round(100 * event.loaded / (this.dialogData.fileSize || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
